import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BaseTextField } from '../../../../shared/components';
import { formatNumber } from '../../../../shared/utils/misc';

/**
 * FormFieldWrapper defaults to width: 100%, which inside the flex row below makes a field
 * claim the whole row and push its siblings past the edge of the Accounting card. Every
 * field here must opt out of that — and must stay shrinkable, since the row is also shown
 * inside the Quotation dialog, where the card is narrower than on the New Job screen.
 *
 * `minWidth: 0` on both the wrapper and the grid it renders is what actually lets a field
 * give way: without it the nowrap label plus the fixed-width box set a floor that no amount
 * of flex-shrink can go under, and the last field ends up outside the card.
 */
const fieldWrapperSx = {
  width: 'auto',
  flex: '0 1 auto',
  minWidth: 0,
  maxWidth: '100%',
  '& label': { color: 'grey.500', whiteSpace: 'normal' },
  '& > div': { minWidth: 0 },
};

/** Shrinks from its natural 180px rather than holding the row open. */
const fieldSx = { flex: '0 1 180px', width: 180, minWidth: 0, maxWidth: '100%' };

export default function GrossTotalSection({ baseAmount, gstAmount, grossTotal }) {
  return (
    <Box
      sx={{
        display: 'grid',
        // The heading moves above the fields on a narrow card rather than eating 10rem of it.
        gridTemplateColumns: { xs: '1fr', sm: '10rem minmax(0, 1fr)' },
        columnGap: 2,
        rowGap: 1,
        alignItems: 'center',
        minWidth: 0,
      }}
    >
      <Typography variant='body1' fontWeight={500} sx={{ whiteSpace: 'nowrap' }}>
        3. Gross Total
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-start',
          columnGap: 2,
          rowGap: 1,
          minWidth: 0,
          maxWidth: '100%',
        }}
      >
        <BaseTextField
          id='gross-field-1'
          onChange={() => {}}
          label='Total cost'
          value={formatNumber(baseAmount)}
          prefix='₹'
          readOnly
          orientation='row'
          wrapperSx={fieldWrapperSx}
          sx={fieldSx}
        />
        <span className='text--secondary'>+</span>
        <BaseTextField
          id='gross-field-2'
          onChange={() => {}}
          label='GST (18%)'
          value={formatNumber(gstAmount == null ? gstAmount : Math.round(Number(gstAmount) * 100) / 100)}
          prefix='₹'
          readOnly
          orientation='row'
          wrapperSx={fieldWrapperSx}
          sx={fieldSx}
        />
        <span className='text--secondary'>=</span>
        <BaseTextField
          id='gross-field-3'
          onChange={() => {}}
          label='Gross total'
          value={formatNumber(grossTotal)}
          prefix='₹'
          readOnly
          orientation='row'
          wrapperSx={fieldWrapperSx}
          sx={fieldSx}
        />
      </Box>
    </Box>
  );
}
